import PauseIcon from './PauseIcon';

export default PauseIcon;
